// extracted by mini-css-extract-plugin
module.exports = {"contentBottom":"favorite-note_contentBottom__Jh6Wq","removeMobile":"favorite-note_removeMobile__vdWGz","removeDesktop":"favorite-note_removeDesktop__nvetZ"};